import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

export const fetchPendingOrdersReducer = createAsyncThunk(
  "dashboard/fetchPendingOrders",
  async ({ status = "Received", page = 1, limit = 5 } = {}, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const queryParamsObj = { page: String(page), limit: String(limit) };
      if (status) {
        queryParamsObj.status = status;
      }
      const queryParams = new URLSearchParams(queryParamsObj).toString();
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.physioDashboardPendingOrders}?${queryParams}`;
      const response = await axiosPrivate.get(fullUrl);

      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      } else {
        const msg = response?.data?.message || "Failed to fetch pending orders.";
        toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      console.error("Error fetching pending orders:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while fetching pending orders.";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);
